import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ChatBubbleCommunicationService {
  editingInProgress: boolean;
  transcriptChanged: BehaviorSubject<boolean> = new BehaviorSubject(true);
  isChangedWords: boolean;
  disableHighlight: boolean;
  autoScrollEnabled$: BehaviorSubject<boolean> = new BehaviorSubject(true);
  programmaticScroll$: BehaviorSubject<boolean> = new BehaviorSubject(false);
}
